import { useEffect, useState } from 'react'

import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

import './circular-progress-loader.scss'

export const useCircularProgressLoader = (animationTime = 6) => {

  const progressPercentage = animationTime * 1000 / 100

  const [progress, setProgress] = useState(0)
  const [isEnded, setIsEnded] = useState(false)

  useEffect(() => {
    if (progress < 100) {
      setTimeout(() => {
        setProgress(progress + 1)
      }, progressPercentage)
      if (progress === 99) {
        setIsEnded(true)
      }
    }
  }, [progress, setProgress])

  return {
    progress, 
    isEnded
  }
}

export const CircularProgressLoader = ({ children, progress }) => {

  return (
    <div className="circular-progress">
      <CircularProgressbarWithChildren 
        value={progress}
        className="circular-progress__loader"
      >
        {children}
      </CircularProgressbarWithChildren>
    </div>
  )
}
